import { Link } from 'react-router-dom';
import { useTheme, useMediaQuery } from '@mui/material';

interface HeaderProps {
  showBackLink?: boolean;
}

export default function Header({ showBackLink = false }: HeaderProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <header style={{
      backgroundColor: '#003366',
      color: 'white',
      padding: isMobile ? '1rem 0' : '1.5rem 0',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: isMobile ? '0 1rem' : '0 2rem',
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        alignItems: isMobile ? 'flex-start' : 'center',
        gap: isMobile ? '0.75rem' : '1rem'
      }}>
        <Link to="/" style={{ textDecoration: 'none', display: 'flex' }}>
          <div style={{
            width: isSmallMobile ? '140px' : '180px',
            height: isSmallMobile ? '60px' : '80px',
            backgroundColor: 'white',
            borderRadius: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <img 
              src="/boesche-logo.png" 
              alt="Boesche Logo" 
              style={{ 
                width: isSmallMobile ? '140px' : '180px', 
                height: isSmallMobile ? '60px' : '80px' 
              }} 
            />
          </div>
        </Link>

        <div style={{ flex: 1, width: isMobile ? '100%' : 'auto' }}>
          {showBackLink && (
            <Link to="/" style={{
              color: 'white',
              textDecoration: 'none',
              fontSize: isMobile ? '0.85rem' : '0.9rem',
              opacity: 0.9,
              display: 'block',
              marginBottom: '0.5rem'
            }}>
              ← Zurück zur Startseite
            </Link>
          )}
          <h1 style={{
            margin: 0,
            fontSize: isMobile ? '1.25rem' : '1.75rem',
            fontWeight: '600'
          }}>
            CRM Boesche
          </h1>
          <p style={{
            margin: '0.25rem 0 0 0',
            fontSize: isMobile ? '0.85rem' : '0.95rem',
            opacity: 0.9
          }}>
            Verwaltungssystem für Kampagnen
          </p>
        </div>
      </div>
    </header>
  );
}
